import React from 'react';
import { useDispatch } from 'react-redux';
import WishlistHeaderIcon from '@westwing/ui-kit/Icons/WishlistHeaderIcon';
import { IconItemWrapper, ItemWrapper, MenuIconWrapper, MenuLabel } from './IconsButtonTray.styles';
import CountBubble from './CountBubble';
import useTranslator from 'Client/hooks/useTranslator';
import useGa from 'Client/hooks/useGa';
import { TrackHeaderActions } from 'Common/ga/types';
import { VictorQaClasses } from 'Common/qaIds';
import { setRedirectUrl } from 'Client/redux/user/actions';
import { remoteLoginEvent } from 'Common/events/service';
import useBellaPush from 'Client/hooks/useBellaHistoryPush';
import useLoginAndRegisterOverlayWithTracking from 'Client/hooks/useLoginAndRegisterOverlayWithTracking';

interface WishlistMenuItemProps {
    wishListUrl: string;
    email?: string;
    wishListItemCount: number;
    isLoggedIn: boolean;
    isPartiallyLoggedIn: boolean;
}

export const WishlistMenuItem = ({
    wishListUrl,
    wishListItemCount,
    isLoggedIn,
    isPartiallyLoggedIn,
    email,
}: WishlistMenuItemProps) => {
    const dispatch = useDispatch();
    const t = useTranslator();
    const remoteLogin = remoteLoginEvent();
    const bellaPush = useBellaPush();
    const ga = useGa();
    const {
        showLoginAndRegisterOverlay,
        trackLoginOverlayShow,
        trackRegistrationOverlayShow,
    } = useLoginAndRegisterOverlayWithTracking();

    const handleWishListClick = () => {
        ga.oneHeader.trackHeaderAction('wishlisticonclick', TrackHeaderActions.HeaderWishlistClick);

        if (!isLoggedIn || isPartiallyLoggedIn) {
            dispatch(setRedirectUrl(wishListUrl));
            showLoginAndRegisterOverlay({ isLogin: isPartiallyLoggedIn });
            trackLoginOverlayShow({ isLogin: isPartiallyLoggedIn, origin: 'wishlistBtn' });
            if (!isLoggedIn) {
                trackRegistrationOverlayShow('wishlistBtn');
            }
            remoteLogin({ redirectUrl: wishListUrl, email, isLogin: isPartiallyLoggedIn });
            return;
        }
        bellaPush(wishListUrl);
    };

    return (
        <ItemWrapper
            className={`WishlistCount ${VictorQaClasses.headerWishlistLink}`}
            onClick={handleWishListClick}
            data-testid="wishlist-bubble"
        >
            <IconItemWrapper>
                <MenuIconWrapper>
                    <WishlistHeaderIcon className="icon-wishlist" />
                    {isLoggedIn && wishListItemCount > 0 && (
                        <CountBubble
                            count={wishListItemCount}
                            counterTestId="wishlist-counter"
                            className={VictorQaClasses.headerWishlistCounter}
                        />
                    )}
                </MenuIconWrapper>
                <MenuLabel>{t('Wishlist_Desktop')}</MenuLabel>
            </IconItemWrapper>
        </ItemWrapper>
    );
};
